export default __webpack_public_path__ + "static/media/Odin-Logo-blue.a86e9656.svg";